import Route from 'cio/routes/base';

// Campaigns can be created without a trigger type, however, users should not
// be able to visit the workflow, goal, and review pages without a trigger
// type.

export default class RequiresTriggerTypeRouteRoute extends Route {
  afterModel(model) {
    super.afterModel(...arguments);

    // If the campaign has a type or it's an API triggered broadcast, we do not
    // need to redirect.
    if (!model.isTypeNone || model.isApiTriggered) {
      return;
    }

    this.router.transitionTo('campaigns.campaign.setup.trigger', model);
  }
}
